<!--Section: Magazine v.3-->
<section class="magazine-section my-5  text-center">

  <!-- Section heading -->
  <h2 class="h1-responsive color-primary my-5">Methoden</h2>
  <!-- Section description -->
  <p class="px-5 mb-5 pb-3 lead text-dark text-left col-lg-8 mx-auto">Die Gründerinnen von eo ipso verfügen, durch
    langjährige
    Berufserfahrung und vielfältig angewandte Weiterbildungen und Qualifikationen, über ein breitgefächertes Angebot an
    Methoden und Techniken.
    Unserer systemischen Grundhaltung entsprechend haben wir das systemische Methodenrepertoire verinnerlicht und leben
    dieses alltäglich in unserer Arbeit mit den Klienten und Klientinnen.
  </p>

  <div class="col-lg-12">
    <!-- Grid row -->
    <div class="row" style="justify-content: center;">

      <div class="col-lg-4 col-md-12 mb-lg-0 mb-5" style="max-width:640px">
        <!-- Featured news -->
        <div class="single-news mb-3">

          <!-- Image -->
          <div class="view overlay rounded z-depth-2 mb-4" style="max-height:600px">
            <img class="img-fluid" src="../../assets/img/gallery/wurzelweg_640.jpg">
            <a>
              <div class="mask rgba-white-slight waves-light" mdbWavesEffect></div>
            </a>
          </div>
          <h3 class="h3-responsive color-primary my-5">Begleitete Umgangskontakte</h3>
          <p class="px-5 mb-5 pb-3 lead text-dark text-left   mx-auto">


            Gelegentlich kann oder darf der Kontakt zwischen Kindern und ihren Eltern oder nahen
            Bezugspersonen nicht „einfach so“ umgesetzt werden. Hierfür gibt es ganz unterschiedliche
            Gründe, es geht jedoch in jedem Fall darum, die Bedürfnisse und den Schutz der Kinder zu
            wahren.
          </p>

          <p class="px-5 mb-5 pb-3 lead text-dark text-left   mx-auto">
            Bei Begleiteten Umgangskontakten bietet eo ipso Kindern und ihren Eltern oder nahen
            Bezugspersonen die Chance, dass miteinander Qualitätszeit verbracht wird und im besten Falle
            ein Dialog hergeleitet werden kann, welcher die Entwicklung der Kinder positiv beeinflusst.
            In den Räumlichkeiten von eo ipso - und nach Absprache und Einverständnis aller Beteiligter auch
            gerne in der Natur, auf Spielplätzen oder der Skaterbahn, in der Eisdiele … - finden Kinder und
            Eltern einen geschützten Rahmen regelmäßig Zeit miteinander zu verbringen.
            Die rechtliche Grundlage für den Begleiteten Umgang ist in §1684 Abs. 4, Sätze 3 und 4 BGB
            sowie in §1685 BGB festgelegt und wird in Absprache mit dem zuständigen Jugendamt oder auf
            gerichtliche Anordnung hin umgesetzt.
          </p>
        </div>
        <!-- Featured news -->





      </div>




      <div class="col-lg-4 col-md-12 mb-lg-0 mb-5" style="max-width:640px">

        <!-- Featured news -->
        <div class="single-news mb-3">

          <!-- Image -->
          <div class="view overlay rounded z-depth-2 mb-4" style="max-height:600px">
            <img class="img-fluid" src="../../assets/img/gallery/tgp_640.jpg">
            <a>
              <div class="mask rgba-white-slight waves-light" mdbWavesEffect></div>
            </a>
          </div>
          <h3 class="h3-responsive color-primary my-5">Tiergestützte Pädagogik</h3>
          <p class="px-5 mb-5 pb-3 lead text-dark text-left   mx-auto">


            Das Angebot der Tiergestützten Pädagogik wird durch uns als zusätzliches Hilfsangebot - zum Beispiel im
            Rahmen einer sozialpädagogischen Familienhilfe - angeboten. Die angeleitete pädagogische Arbeit zwischen
            Klienten und Tier dient in der Regel sowohl als Türöffner für intensive sozialarbeiterische Intervention,
            als auch als entlastende Alltagsunterbrechung. Eine Kooperation von eo ipso mit einer Reitschule in Würselen
            besteht. Kinder und Erwachsene können in Kontakt kommen zu Pferden, Eseln, Ponys, Kühen, Meerschweinchen und
            Hasen.
          </p>
          <h4 class="h4-responsive color-primary my-5"> Warum Tiergestütze Pädagogik?</h4>
          <p class="px-5 mb-5 pb-3 lead text-dark text-left   mx-auto">
            Kinder und Jugendliche nehmen unbefangen den Kontakt zu Tieren auf bzw. lernen in einfühlsamer Begleitung
            möglicherweise bestehende Vorbehalte zu bearbeiten. Der körperliche Kontakt mit dem Tier löst Verhärtungen.
            Angstfreie Zärtlichkeiten öffnen den Weg zu psychischer Sensibilität. Tiere wollen umworben werden, sie
            biedern sich nicht an, um so stärker wirkt die Erfahrung gewonnener Zuneigung. Tiere vermitteln
            Verantwortungsgefühl, Tiere vermitteln Erfolgserlebnisse. Das Tier ist geduldig, erzieht gleichermaßen zur
            Geduld und sendet keine Signale der Ablehnung aus.
          </p>
        </div>
        <!-- Featured news -->
      </div>



      <div class="col-lg-4 col-md-12 mb-lg-0 mb-5" style="max-width:640px">
        <!-- Featured news -->
        <div class="single-news mb-3">

          <!-- Image -->
          <div class="view overlay rounded z-depth-2 mb-4" style="max-height:600px">
            <img class="img-fluid" src="../../assets/img/gallery/farben_640.jpg">
            <a>
              <div class="mask rgba-white-slight waves-light" mdbWavesEffect></div>
            </a>
          </div>
          <h3 class="h3-responsive color-primary my-5">Pädagogische Kunsttherapie</h3>
          <p class="px-5 mb-5 pb-3 lead text-dark text-left   mx-auto">


            In der pädagogischen Kunsttherapie werden gestalterische Angebote gezielt unterbreitet, um
            Menschen Möglichkeiten des symbolischen Ausdrucks zu verschaffen. Kunstpädagogische
            Erfahrungen ermöglichen u.a. Nachreifung auf verschiedenen Ebenen. Die eigene Phantasie,
            Stimmungen und Affekte werden in der Zusammenarbeit mit den Klienten gestalterisch dargestellt.
            Dabei werden unterschiedlichste Materialien und Methoden angewandt.

          </p>
          <h4 class="h4-responsive color-primary my-5">Angebote</h4>

          <div style="padding-left:50px;font-size: large;">
            <ul class="text-dark text-left lead">
              <li>Zeichen</li>
              <li>Malen</li>
              <li>Tonarbeiten</li>
              <li>Medienarbeiten</li>
              <li>Geschichten erzählen und gestalten</li>
              <li>Beziehungsbilder</li>
              <li>Bilder erweitern etc.</li>
            </ul>
          </div>


        </div>
        <!-- Featured news -->





      </div>



      <div class="col-lg-4 col-md-12 mb-lg-0 mb-5" style="max-width:640px">

        <!-- Featured news -->
        <div class="single-news mb-3">

          <!-- Image -->
          <div class="view overlay rounded z-depth-2 mb-4" style="max-height:600px">
            <img class="img-fluid" src="../../assets/img/gallery/kunst_640.jpg">
            <a>
              <div class="mask rgba-white-slight waves-light" mdbWavesEffect></div>
            </a>
          </div>
          <h3 class="h3-responsive color-primary my-5">Aufsuchenden Familientherapie</h3>
          <p class="px-5 mb-5 pb-3 lead text-dark text-left   mx-auto">


            Die Aufsuchende Familientherapie ist ein therapeutisches Angebot für Familien, in denen das Wohl von Kindern
            und Jugendlichen gefährdet ist. Wir gehen davon aus, dass Verhaltensauffälligkeiten und oder einzelne
            Symptome nicht dem einzelnen Familienmitglied zuzuschreiben sind, sondern dazu dienen das Familiensystem in
            dem Kontext des Systems aufrecht zu erhalten.
          </p>
          <p class="px-5 mb-5 pb-3 lead text-dark text-left   mx-auto">
            Wir arbeiten in der Aufsuchenden Familientherapie zu Zweit und im Co-Therapeuten-Team. Ziel dabei ist, für
            die Familien einen Unterschied herzuleiten, der einen Unterscheid für die Familien macht. In einer
            gemeinsamen Arbeit mit den Kindern, Jugendlichen und Eltern suchen wir nach geeigneten Lösungsstrategien, um
            Ressourcen wieder nutzbar zu machen und im besten Fall destruktive Verhaltensmuster zu durchbrechen und
            andere Lösungen mit den Familien zu erarbeiten.
          </p>
          <p class="px-5 mb-5 pb-3 lead text-dark text-left   mx-auto">
            Als Mittel stehen uns hierbei mannigfaltige Methoden zur Verfügung, die speziell in dem Einzelfall
            angewendet werden kann. Grundsätzlich verstehen wir all unsere angebotene Arbeit als systemisches Handeln
            und Denken. In der aufsuchenden Familientherapie wird der Schwerpunkt auf eine systemische Diagnostik
            gelegt. Das Ziel in der Aufsuchenden Familientherapie ist es, die Verantwortung für die Erarbeitung von
            möglichen Lösungen von Beginn an bei den Familien zu belassen und nicht kompensatorisch für die Familie zu
            übernehmen. Auch hier gehen wir in der AFT davon aus, dass die Familie der Experte für ihre eigene Familie
            ist. Wir möchten dabei helfen, die Sitzordnung an dem Familientisch neu zu justieren.

          </p>

 
        </div>
        <!-- Featured news -->
      </div>

      <div class="col-lg-4 col-md-12 mb-lg-0 mb-5" style="max-width:640px">

        <!-- Featured news -->
        <div class="single-news mb-3">

          <!-- Image -->
          <div class="view overlay rounded z-depth-2 mb-4" style="max-height:600px">
            <img class="img-fluid" src="../../assets/img/gallery/hase_640.jpg">
            <a>
              <div class="mask rgba-white-slight waves-light" mdbWavesEffect></div>
            </a>
          </div>
          <h3 class="h3-responsive color-primary my-5">Kreative Kindertherapie</h3>
          <p class="px-5 mb-5 pb-3 lead text-dark text-left   mx-auto">


            <i>Systemisch-lösungsorientierte Therapie mit Kindern und Jugendlichen</i><br>

            Durch den Einsatz von unterschiedlichen Methoden, Techniken und Materialien wird mit dem Kind
            oder Jugendlichen, ggf. mit der gesamten Familie, versucht, Lösungen herzuleiten. Dabei werden
            kreative Möglichkeiten, mit dem Ziel Verständnis miteinander oder für den Einzelnen herzuleiten,
            angeboten. Angefangen von Figurenmalbüchern, Ressourcen - Genogrammen aus Süßigkeiten bis hin
            zu hypnotherapeutischer Arbeit werden Wege zur Lösung geebnet.
          </p>



          <p class="px-5 mb-5 pb-3 lead text-dark text-left   mx-auto">
            Fachlich handelt sich um eine grundlegende systemisch-lösungsorientierte Therapieform. Diese ist
            abzugrenzen von der psychotherapeutischen Intervention und beinhaltet:
          </p>

          <div style="padding-left:50px;font-size: large;">
            <ul class="text-dark text-left text-left lead">
              <li>Entwicklungs- und Ressourcendiagnostik</li>
              <li>Indikationsstellung</li>
              <li>Rapportstrategien und Beziehungsgestaltung</li>
              <li>Externalisieren</li>
              <li>Teile-Arbeit und Cartoon-Therapie</li>
              <li>Urkunden und Rituale für Kinder und Jugendliche erarbeiten</li>
              <li>Lösungsorientierte Elternberatung</li>
            </ul>
          </div>




        </div>
        <!-- Featured news -->
      </div>



    </div>
    <!-- Grid row -->

  </div>
</section>
<!--Section: Magazine v.3-->